/**
 * Where a submitted paper lands — an exam, a teacher's class paper, a mini
 * test, a diagnostic.
 *
 * One sheet, not five tabs: marks, the question view, topics and time are
 * columns on the mastery sheet now, so a student reads one document instead of
 * comparing five. The page is only a frame; the sheet is shared with the
 * Progress tab and the teacher's one-student view so the three cannot drift.
 */
import { useParams } from 'react-router-dom';
import { StudentPage, StudentPageHeader } from '@/components/ds';
import { MasterySheet } from '@/components/reports/MasterySheet';

export function ReportPage() {
  const { spId = '' } = useParams();

  return (
    <StudentPage className="gap-4">
      <StudentPageHeader
        breadcrumbs={[{ label: 'Tests & papers', to: '/tests' }, { label: 'Report' }]}
        title="Your report"
        subtitle="One sheet, five bands. Green at the top is what you own; the rows below it are the marks still waiting for you."
        action={
          <button
            type="button"
            onClick={() => window.print()}
            className="rounded-full px-3.5 py-2 text-xs font-bold transition"
            style={{ background: 'var(--paper-sunk)', color: 'var(--ink-2)' }}
          >
            Print sheet
          </button>
        }
      />

      <MasterySheet spId={spId} />
    </StudentPage>
  );
}
